module.exports = __webpack_public_path__ + "front/img/edm-bj-xianshang.558bc64d.png";